export const prefix = 'ilbIconList';